import styled from 'styled-components'
import { StyledButton } from '../Form/Button'

export const Container = styled.div`
  width: 100%;
  margin-top: 16px;

  ${StyledButton} {
    color: #028BB7;
    border-color: #028BB7;
  }
`
